<template>
  <section class="scrollable">
    <nav class="navbar navbar-expand-lg navbar-light bg-dark px-5 mb-5">
      <a class="navbar-brand" href="/">
        <img alt="Indiefy Network" class="mr-2" src="/static/img/logo-contorno-white.png" width="25" height="25"> <span class="text-white font-thin">Indiefy Network</span>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
        </ul>
        <div class="my-2 my-lg-0">
          <a href="https://indiefy.net/services" class="btn btn-lg mr-4 text-white">{{ $t('more_services') }}</a>
          <a href="https://indiefy.net" class="btn btn-lg mr-4 text-white">{{ $t('music_distribution') }}</a>
        </div>
      </div>
    </nav>
    <section class="bg-white scrollable">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="mb-2">
              <h2 class="text-primary strong">
                {{ $t('landing_title') }}
              </h2>
              <p class="h4 text-dark-dker" v-html="$t('landing_description')">
              </p>
              <img src="/static/img/chart-screen.png" alt="" width="100%" class="mt-2 mb-2">
            </div>
          </div>
          <div class="col-md-4">
            <div class="login">
              <div class="login-container">
                <h2 class="text-dark-dker strong text-center" v-if="!showSignup">{{ $t('sign_in_indiefy') }}</h2>
                <h2 class="text-dark-dker strong text-center" v-if="showSignup">{{ $t('register') }}</h2>
                <div class="panel panel-default login-panel">
                  <div class="panel-body" v-if="showSignup">
                    <form @submit.prevent="register()">
                      <input type="email" class="form-control" placeholder="Email" v-model="newUser.email" name="email"/>
                      <input type="password" class="form-control mt-1" placeholder="Password" v-model="newUser.password" name="password"/>
                      <input type="password" class="form-control mt-1" placeholder="Repeat password" v-model="passwordConfirm" name="password2"/>
                      <button type="submit" class="btn btn-primary btn-block mt-1">
                        {{ $t('create_account') }}
                      </button>
                      <button type="button" class="btn btn-default btn-block mt-1" @click="showSignup = false">
                        {{ $t('cancel') }}
                      </button>
                    </form>
                  </div>
                  <div class="panel-body" v-if="!showSignup">
                    <button type="button" class="btn btn-info btn-block btn-facebook" @click="facebookLogin()">
                      <i class="fab fa-facebook mr-2"></i>
                      {{ $t('login_facebook') }}
                    </button>
                    <button type="button" class="btn btn-danger btn-block" @click="googleLogin()">
                      <i class="fab fa-google mr-2"></i>
                      {{ $t('login_google') }}
                    </button>
                    <p class="my-4 text-center">{{ $t('or') }}</p>
                    <form @submit.prevent="login()">
                      <input type="text" class="form-control" placeholder="Email" v-model="email" name="email" required/>
                      <input type="password" class="form-control mt-1" placeholder="Password" v-model="password" name="password" required/>
                      <div class="p-2" v-html="captchaSvg"></div>
                      <input type="text" class="form-control mt-1" placeholder="Captcha" v-model="captcha" name="captcha" required/>
                      <button type="submit" class="btn btn-primary btn-block mt-1">
                        {{ $t('sign_in') }}
                      </button>
                      <button type="button" class="btn btn-default btn-block mt-1" @click="showSignup = true">
                        {{ $t('create_account') }}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="p-4 mb-4 mt-2"></div>
  </section>
</template>
<script>

import _ from 'underscore'

export default {
  data: function () {
    return {
      captchaSvg: '',
      captcha: '',
      email: '',
      password: '',
      showSignup: false,
      newUser: {
        username: '',
        email: '',
        password: ''
      },
      passwordConfirm: ''
    }
  },
  mounted: function () {
    this.getCaptcha()
  },
  created () {
    this.initGoogleApi()
    // location.href = loginUrl
  },
  methods: {
    getCaptcha: function () {
      this.captchaSvg = ''

      this.$http.get(`${window.apiURL}auth/captcha`, { withCredentials: true }).then(response => {
        this.captchaSvg = response.data
      })
    },
    register: function () {
      if (!this.newUser.email) {
        return
      }

      if (!this.newUser.password) {
        return
      }

      if (this.newUser.password !== this.passwordConfirm) {
        return alert(this.$t('passwords_dont_match'))
      }

      this.newUser.username = `${this.newUser.email.split('@')[0]}_${parseInt(Math.random() * 1000 + 100)}`
      this.$http.post(`${window.apiURL}auth/register`, this.newUser, { withCredentials: true }).then(response => {
        this.user = response.data
        localStorage.setItem('user', JSON.stringify(this.user))
        this.$router.push('/campaigns')
        this.$eventBus.$emit('loggedIn')
      }, error => {
        let message = error.response.data.name

        if (message === 'user_already_exists') {
          alert(this.$t('user_exists'))
        } else if (message === 'email_already_exists') {
          alert(this.$t('user_exists'))
        }
      })
    },
    initGoogleApi: function () {
      const initClient = () => {
        window.gapi.client.init({
          apiKey: 'AIzaSyCh6wL8WnwV3O3VksWQ2_sIpQxAewn31Aw',
          discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1'],
          clientId: '551586398920-cpk7un4cut3kgvo4ocusoqfjcpf8oeif.apps.googleusercontent.com',
          scope: 'profile'
        })
      }

      if (!window.gapi.auth2.getAuthInstance()) {
        window.gapi.load('client:auth2', () => {
          initClient()
        })
      } else {
        initClient()
      }
    },
    googleLogin: function () {
      if (!window.gapi) return

      const options = new window.gapi.auth2.SigninOptionsBuilder()
      options.setPrompt('select_account')
      window.gapi.auth2.getAuthInstance().signIn(options).then(() => {
        window.gapi.client.people.people.get({
          'resourceName': 'people/me',
          'requestMask.includeField': 'person.names,person.email_addresses,person.photos,person.metadata'
        }).then(response => {
          const userData = {
            id: _.find(response.result.metadata.sources, { type: 'PROFILE' }).id,
            email: response.result.emailAddresses[0].value,
            name: response.result.names[0].displayName,
            profile_image: response.result.photos[0].url,
            lang: this.$i18n.locale
          }

          this.$http.post(`${window.apiURL}auth/google-login`, userData, { withCredentials: true }).then(response => {
            this.user = response.data
            localStorage.setItem('user', JSON.stringify(this.user))
            this.$router.push('/campaigns')
            this.$eventBus.$emit('loggedIn')
          }).catch(() => {
            this.getCaptcha()
          })
        })
      })
    },
    facebookLogin: function () {
      const facebookScope = 'public_profile,email,user_friends'

      FB.login(response => {
        if (response.status === 'connected') {
          FB.api('/me?fields=name,picture,first_name,last_name,email', userData => {
            if (this.$i18n.locale) {
              userData.lang = this.$i18n.locale
            }

            this.$http.post(`${window.apiURL}auth/facebook-login`, userData, { withCredentials: true }).then(response => {
              this.user = response.data
              localStorage.setItem('user', JSON.stringify(this.user))
              this.$router.push('/campaigns')
              this.$eventBus.$emit('loggedIn')
            }).catch(() => {
              this.getCaptcha()
            })
          })
        }
      }, { scope: facebookScope })
    },
    login: function () {
      if (!this.email || !this.password || !this.captcha) {
        return
      }

      this.$http.post(`${window.apiURL}auth/login`, { username: this.email, password: this.password, captcha: this.captcha }, { withCredentials: true }).then(response => {
        this.user = response.data
        localStorage.setItem('user', JSON.stringify(this.user))
        this.$router.push('/campaigns')
        this.$eventBus.$emit('loggedIn')
      }).catch(error => {
        console.log('Error', error.response.data)
        let response = error.response.data || {}

        if (response.name === 'invalid_username') {
          alert(this.$t('user_not_found'))
        }

        if (response.name === 'invalid_password') {
          alert(this.$t('invalid_password'))
        }

        if (response.name === 'unconfirmed') {
          alert(this.$t('please_confirm_email'))
        }

        if (response.name === 'invalid_captcha') {
          alert(this.$t('invalid_captcha'))
        }

        this.getCaptcha()
      })
    }
  }
}
</script>
<style scoped>
  .nav ul li a:hover {
    color: #49b5e7;
  }

  .navbar-primary .navbar-nav > li > a:hover, .navbar-primary .navbar-nav > li > a:focus {
    color: #49b5e7;
  }

  .navbar {
    border-radius: 0;
  }

  .btn-facebook {
    background-color: #4267b2;
    border-color: #4267b2;
  }

  .btn-facebook:hover {
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue